import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, MailStatus } from '../api';
import { ErrorBox, fmtDate, useAsync } from '../components/ui';

const PROVIDER: Record<string, string> = { google: 'Google', microsoft: 'Microsoft 365', fake: 'Teszt-postafiók' };

/** Saját postafiók csatolása: levelek a kontaktok idővonalára, feladatok a naptárba, küldés a CRM-ből. */
export function MailboxPage() {
  const [params, setParams] = useSearchParams();
  const [st, setSt] = useState<MailStatus | null>(null);
  const [digest, setDigest] = useState<boolean | null>(null);
  const a = useAsync();
  const load = () => a.run(async () => setSt(await api<MailStatus>('/mail/status')));
  useEffect(() => { load(); api<{ daily_digest: boolean }>('/me/prefs').then((p) => setDigest(p.daily_digest)).catch(() => setDigest(null)); }, []);
  const setPref = async (on: boolean) => { const r = await a.run(() => api<{ daily_digest: boolean }>('/me/prefs', { method: 'PUT', body: { daily_digest: on } })); if (r) setDigest(r.daily_digest); };
  const connect = async (provider: string) => { const r = await a.run(() => api<{ url: string }>('/mail/connect', { method: 'POST', body: { provider } })); if (r) window.location.href = r.url; };
  const patch = async (b: Record<string, boolean>) => { if (await a.run(() => api('/mail/account', { method: 'PATCH', body: b }))) load(); };
  const sync = async () => { if (await a.run(() => api('/mail/sync', { method: 'POST' }))) { setTimeout(load, 4000); load(); } };
  const disconnect = async () => { if (window.confirm('Leválasztod a postafiókot? A már rögzített levelek a CRM-ben maradnak, a naptárba írt események megmaradnak.') && await a.run(() => api('/mail/disconnect', { method: 'POST' }))) load(); };
  const acct = st?.account;
  return (
    <div>
      <div className="page-head"><h2>Postafiók és naptár</h2></div>
      {params.get('connected') && <div className="notice">A postafiók csatolva. Az első szinkron pár percen belül lefut. <button className="link inline" onClick={() => setParams({})}>×</button></div>}
      {params.get('error') && <div className="error">A csatolás nem sikerült: {params.get('error')}</div>}
      <ErrorBox error={a.error} />
      <div className="cols">
        <section className="card">
          {acct ? (
            <>
              <h3>{acct.email} <span className="badge">{PROVIDER[acct.provider] ?? acct.provider}</span>
                {acct.status === 'error' && <span className="badge badge-risk-external">hiba</span>}</h3>
              {acct.error && <div className="error">{acct.error}{acct.status === 'error' && ' – csatold újra a fiókot.'}</div>}
              <p className="muted small">Utolsó szinkron: {acct.last_sync_at ? fmtDate(acct.last_sync_at) : 'még nem volt'} · naptárban követett feladat: {st!.calendar_tasks}</p>
              <label className="check"><input type="checkbox" checked={acct.mail_sync} onChange={(e) => patch({ mail_sync: e.target.checked })} /> Levelek a kontaktok idővonalára</label><br />
              <label className="check"><input type="checkbox" checked={acct.calendar_sync} onChange={(e) => patch({ calendar_sync: e.target.checked })} /> Határidős feladataim a naptáramba (kétirányú)</label><br />
              {digest !== null && <label className="check"><input type="checkbox" checked={digest} onChange={(e) => setPref(e.target.checked)} /> Reggeli összefoglaló e-mailben (lejárt és mai teendők, elakadt dealek, válaszra váró ajánlatok, lejárt számlák)</label>}
              <div className="actions">
                <button className="secondary" onClick={sync} disabled={a.busy}>Szinkron most</button>
                {acct.status === 'error' && <button onClick={() => connect(acct.provider)}>Újracsatolás</button>}
                <button className="danger" onClick={disconnect} disabled={a.busy}>Leválasztás</button>
              </div>
            </>
          ) : (
            <>
              <h3>Csatold a postafiókodat</h3>
              {st && st.providers.length === 0 && <p className="muted">A szerveren még nincs beállítva Google- vagy Microsoft-kapcsolat. Kérd meg az üzemeltetőt (lásd a telepítési leírást).</p>}
              <div className="actions">{st?.providers.map((p) => <button key={p.name} onClick={() => connect(p.name)} disabled={a.busy}>{p.label} csatolása</button>)}</div>
            </>
          )}
        </section>
        <section className="card">
          <h3>Mi kerül a CRM-be?</h3>
          <ul className="small tight">
            <li>Csak azok a levelek, amelyekben a CRM-ben már szereplő kontakt a feladó vagy a címzett – a postafiókod többi része nem.</li>
            <li>A levél a kontakt és a cége idővonalára kerül (az idézett előzmények nélkül). Az első szinkron az utolsó 30 nap leveleit nézi át.</li>
            <li>A határidős, nyitott feladataid a naptáradba kerülnek; ha ott áthelyezed, a CRM-ben is módosul. A naptárad többi eseménye nem kerül be.</li>
            <li>Ajánlatot és levelet a CRM-ből a saját címedről küldhetsz; a levél a kontakt idővonalán is megjelenik.</li>
            <li>A reggeli összefoglalót a CRM minden nap 7 óra után a saját postafiókodból küldi neked.</li>
            <li>Ha be van kapcsolva a Beérkező-feldolgozó ügynök, az új levelekből teendőt ír ki; lépésváltást csak javasol.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
